// extracted by mini-css-extract-plugin
export default {"icons":"About_icons__I90dM","icon":"About_icon__x1HUf"};